import { useEffect, useState } from 'react';
import { InvoiceProvider, useInvoice } from '../../common/InvoiceProvider';
import { Box, Card, CardContent, CardHeader, Grid, Typography, Divider, Input } from '@mui/material';
import Spinner from '../../Spinner';
import ErrorSummary from '../../common/ErrorSummary';
import PdfViewer from 'components/common/PdfRenderer';
import { WorkflowProvider, useWorkflow } from 'components/Workflow/WorkflowContext';
import MyInvoicesForm from './MyInvoicesForm';

const MyInvoiceDetailContent = () => {
  const { input, isLoading, errors } = useInvoice();
  const { workflow, loading: workflowLoading } = useWorkflow();
  const [disabledForm, setDisabledForm] = useState<boolean>(false);

  useEffect(() => {
    if (workflow && !workflowLoading) {
      setDisabledForm(!workflow.states.find((state) => state.id === input.idWorkflowState)?.editable);
    }
  }, [workflow, workflowLoading, input.idWorkflowState]);

  return (
    <Box sx={{ mt: 4, px: 2 }}>
      <Card variant="outlined">
        {isLoading && <Spinner />}
        <CardHeader
          title={
            <Typography color="primary" variant="h2">
              Invoice Detail
            </Typography>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid sx={{ xs: 3 }}>
              <ErrorSummary errors={errors} showEverything={true} />
            </Grid>

            <Grid sx={{ xs: 12 }}>
              <Input
                id="idFrom"
                name="idFrom"
                size="small"
                value={input?.personaFrom?.name || ''}
                disabled
                disableUnderline
                sx={{ width: '100%', p: 1, mt: 1, border: '1px solid #ccc', borderRadius: 1 }}
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />
          {input ? (
            <Grid container spacing={2} alignItems="flex-start" sx={{ width: '100%' }}>
              <Grid size={{ xs: 12, md: 5 }} sx={{ minWidth: 0 }}>
                {input?.attachments && (
                  <Box mb={3}>
                    <PdfViewer
                      file={input?.attachments?.[0]}
                      dataURI={input?.attachments?.[0]?.dataUri}
                    />
                  </Box>
                )}
              </Grid>
              <Grid size={{ xs: 12, md: 7 }} sx={{ minWidth: 0 }}>
                <MyInvoicesForm disabled={disabledForm} />
              </Grid>
            </Grid>
          ) : (
            <Spinner />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

const MyInvoiceDetail = () => {
  return (
    <InvoiceProvider review={false} edit={true} view={false}>
      <WorkflowProvider moduleId={4}>
        <MyInvoiceDetailContent />
      </WorkflowProvider>
    </InvoiceProvider>
  );
};

export default MyInvoiceDetail;
